module.exports = __webpack_public_path__ + "static/media/mail-icon.789c0f6c.svg";